import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './navbar.css';

export default function Navbar(){

    const [utype,setutype] = useState([]);
    
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    
    const user = localStorage.getItem("utype");
    const userid = localStorage.getItem("userid") ;
    const username = localStorage.getItem("username");

    console.log(userid);
    console.log(user);

    
    
useEffect(()=>
{
    fetch(API_URL+"api/User/GetUserType").then(response => response.json())
     .then(data => {setutype(data)});
},[])    
 
    return(
            <>
            <nav>
                {/*<div class="logo" >Finance Assitant</div>*/}
                <div style ={{marginTop:"-10px", zIndex:1,display:"inline-block"}}>
                <ul>
                <li><Link to = "/home" className ="link" ><div style={{color:"white"}}> Home </div></Link></li>
                <li><Link to = "/person" className ="link"><div style={{color:"white"}}>New Customer</div></Link></li>
                { user !== "1" ?  <>
                <li><Link to = "/expenses" className ="link"><div style={{color:"white"}}>Expenses</div></Link></li>
                <li><Link to = "/loandetails" className ="link"><div style={{color:"white"}}>Reports</div></Link></li></> :<></>}
                {/* <li><Link to = "/expenses" className ="link"><div style={{color:"white"}}> Expenses</div></Link></li> */}
                {/* <li><Link to = "/loandetails" className ="link"><div style={{color:"white"}}> Reports</div></Link></li> */}
                { user === "1" ?  <>
                <li><Link to = "/accounts" className ="link"><div style={{color:"white"}}>Accounts</div></Link></li>
                {/*  <li><Link to = "/deposits" className ="link"><div style={{color:"white"}}> Deposits</div></Link></li> */}
                <li><Link to = "/changes" className ="link"><div style={{color:"white"}}> Changes</div></Link></li> 
                <li><Link to = "/user" className ="link"><div style={{color:"white"}}> User</div></Link></li> </> : <></>}
                {/* <li><Link to = "/userdayclosing" className ="link"><div style={{color:"white"}}> Userclosing</div></Link></li></> : <></>} */}
                <li><Link to = "/" className ="link"><div style={{color:"white"}}> Logout {username}({userid}) </div></Link></li>
                </ul>
                <div class="menu" style ={{marginTop:"-15px"}} onClick={()=>document.querySelector('nav ul').classList.toggle('showmenu')}>
                    <div class = "menu-line"></div>
                    <div class = "menu-line"></div>
                    <div class = "menu-line"></div>
                </div>
                </div>
            </nav>
            
            </>
            )
}
          
    
    

